import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';

import { Capacitor } from '@capacitor/core';

import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular/standalone';

import { UiBrandingService } from '@core/services/ui-branding.service';

import { OverlaySplash } from '@shared/components/overlay-splash/overlay-splash';
import type { OverlaySplashBranding } from '@shared/components/overlay-splash/overlay-splash.types';

const DEFAULT_SPLASH_DURATION_MS = 5000;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet, OverlaySplash],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly platform = inject(Platform);
  private readonly brandingService = inject(UiBrandingService);

  protected readonly showSplash = signal(Capacitor.isNativePlatform());

  constructor() {
    if (this.showSplash()) {
      const splashConfig = this.getEntrySplashConfig();
      const duration = splashConfig?.minDuration ?? DEFAULT_SPLASH_DURATION_MS;
      const minDuration = new Promise((resolve) => setTimeout(resolve, duration));

      Promise.all([this.platform.ready(), minDuration])
        .then(() => this.showSplash.set(false))
        .catch((error) => {
          console.error('Splash screen init failed during platform.ready():', error);
          this.showSplash.set(false);
        });
    }
  }

  private getEntrySplashConfig(): OverlaySplashBranding | undefined {
    const branding = this.brandingService.branding();
    const components = branding?.['components'] as Record<string, unknown> | undefined;
    return components?.['entrysplash'] as OverlaySplashBranding | undefined;
  }
}
